<template>
  <div class="row cover" style="margin:0 30px">
    <div v-show="!showPassage" class="col-sm-6 cover-child question-box">
      <div class="question" style="opacity: 1;">
        <div class="questions">
          <div
            v-for="(group, index) in passageDetail.ielts_question_sets"
            :key="index"
          >
            <QuestionsGroup :group="group" :review="true"></QuestionsGroup>
            <div class="resolve_content">
              <div class="title">{{ $t("ielts.resolve.Answers") }}:</div>
              <div>
                <p>
                  {{ $t("ielts.resolve.My Answers") }}：
                  <span
                    class="answer"
                    v-for="(question, index) in group.ielts_questions"
                    :key="index"
                  >
                    {{ question.order }}.
                    <span
                      v-if="question.user_answers"
                      :class="
                        question.user_is_correct == 1
                          ? 'text-success'
                          : 'text-danger'
                      "
                      >{{ question.user_answers[0] }}</span
                    >
                    <span v-else class="text-danger">
                      *
                    </span>
                  </span>
                </p>
                <p>
                  {{ $t("ielts.resolve.Correct Answers") }}：
                  <span
                    class="answer"
                    v-for="(question, index) in group.ielts_questions"
                    :key="index"
                  >
                    {{ question.order }}.
                    <span
                      class="text-success"
                      v-for="(question, index) in question.answers[0].answer"
                      :key="index"
                      >{{ question }}</span
                    >
                  </span>
                </p>
              </div>
            </div>
            <hr />
            <div class="resolve_content">
              <div class="title">{{ $t("ielts.resolve.Explanation") }}:</div>
              <div class="exp">
                <p
                  v-for="(question, index) in group.ielts_questions"
                  :key="index"
                  v-show="question.exp"
                >
                  <span v-if="lang === 'ZH-TW' || lang === 'EN-US'">
                    {{ question.order }}.
                    {{ traditionalized(question.exp ? question.exp : "") }}
                  </span>
                  <span v-else> {{ question.order }}. {{ question.exp }} </span>
                </p>
              </div>
            </div>
            <hr class="hr" />
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{
        'col-sm-12': showPassage,
        'col-sm-6': !showPassage,
        'cover-child': true,
        'passage-box': true
      }"
    >
      <div class="passage">
        <span class="article-title">
          {{ passageDetail.article_title }}
        </span>
        <div v-if="passageDetail.audio !== null">
          <div class="row" style="margin-bottom:20px">
            <div class="col-sm-6 text-left">
              <audio
                style="width:100%"
                id="myAudio"
                :src="passageDetail.audio"
                controls
                controlsList="nodownload"
              ></audio>
            </div>
            <div class="col-sm-6 text-center" style="line-height:54px">
              <el-dropdown size="small" @command="changeSpeed">
                <el-button class="audio-speed" size="small" type="success">
                  Speed: <b>{{ speed }} X</b>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in multipleArray"
                    :key="index"
                    :command="item"
                  >
                    {{ item }} X
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div style="margin-bottom:20px">
            <el-alert
              title="Clicking on a sentence in the article will jump the audio to the corresponding time."
              type="success"
              :closable="false"
              effect="dark"
            >
            </el-alert>
          </div>
        </div>
        <div
          class="nano-content_in article"
          v-html="passageDetail.article"
        ></div>
        <div class="open" @click="showPassage = !showPassage">
          <div class="text" v-show="!showPassage">Expand</div>
          <div class="text" v-show="showPassage">Collapse</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import ToeflMixin from "@/mixins/toefl.js";
import Translate from "@/mixins/translate.js";
import QuestionsGroup from "@/views/ielts/ieltsTest/listening/components/QuestionsGroup";
import $ from "jquery";

export default {
  components: {QuestionsGroup},
  props:["passageDetail", "title", "lang"],
  mixins: [ToeflMixin, Translate],
  computed:{},
  data() {
    return {
      showPassage: false,
      multipleArray: [0.8, 1, 1.2, 1.5, 2, 3, 4],
      speed: 1
    };
  },
  watch: {

  },

  mounted() {
    this.$nextTick(() => {
      let vm = this;
      let audio = $("#myAudio")[0];
      $.each($(".phase"), function(key, val) {
        $(val).attr("data-toggle","tooltip");
        let translation = $(val).data("translation");
        if(vm.lang === "ZH-TW" || vm.lang === "EN-US"){
          translation = vm.traditionalized(translation);
        }
        $(val).attr("title",translation);
        $(val).addClass("high-light");
        $(val).click(function(){
          let time = $(val).find("[data-time]").data("time");
          audio.currentTime = time;
          audio.play();
        });
      });
      $("[data-toggle=\"tooltip\"]").tooltip();
    });

  },

  methods: {
    changeSpeed(command) {
      let audioPlayer = document.getElementById("myAudio");
      audioPlayer.playbackRate = command;
      this.speed = command;
    }
  }
};
</script>

<style scoped>
.answer_content .answers {
  margin-right: 20px;
}
.alert-blue {
  color: white;
  background-color: #409eff;
  border-color: #409eff;
}
.article-title {
  font-size: 20px !important;
  color: #494949;
  font-weight: 700;
  display: block;
  text-align: center;
  line-height: 60px;
  height: 60px;
  padding: 0px 0;
}
.article {
  height: calc(100% - 200px);
  overflow: auto;
}
hr.hr {
  border-width: 2px;
  border-color: var(--themeColor);
}
.answer {
  display: inline-block;
  margin-right: 10px;
  font-weight: 500;
}
.exp {
  border: 1px solid var(--themeColor);
  background: #ff770c2e;
}
::v-deep .high-light:hover {
  cursor: pointer;
  background: var(--themeColor);
  color: white;
  padding: 5px 0;
}
.control .el-dropdown {
  width: 100px;
}
.audio-speed {
  display: inline-block;
  width: 100%;
}
</style>
